import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, MapPinIcon, BuildingIcon, GraduationCapIcon } from 'lucide-react';
import { profile } from '../data/profile';
interface HeroProps {
  onRequestBriefing: () => void;
}
const facts = [{
  icon: MapPinIcon,
  text: profile.location
}, {
  icon: BuildingIcon,
  text: profile.entity
}, {
  icon: GraduationCapIcon,
  text: `${profile.education} Alum`
}];
export function Hero({
  onRequestBriefing
}: HeroProps) {
  return <section id="top" className="relative overflow-hidden bg-white pt-16" data-id="element-124" data-mp="xae6cxafgcjp">
      <div aria-hidden="true" className="pointer-events-none absolute right-0 top-0 hidden h-full w-[42%] bg-canvas lg:block" data-id="element-125" data-mp="x8b6lljh351s" />
      <div className="relative mx-auto grid max-w-shell items-center gap-14 px-6 pb-20 pt-16 lg:grid-cols-[1.05fr_0.95fr] lg:gap-20 lg:px-10 lg:pb-28 lg:pt-24" data-id="element-126" data-mp="nczrh245jvti">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-127" data-mp="382fern45x2ee">
          <p className="text-[11px] font-semibold uppercase tracking-overline text-bronze-600" data-id="element-128" data-mp="3j6fxfnpbn9cs">
            Executive Profile
          </p>
          <h1 className="mt-5 font-serif text-5xl leading-[1.05] tracking-tight text-navy sm:text-6xl lg:text-[4.25rem]" data-id="element-129" data-mp="39aupza1hhgvn">
            {profile.name}
          </h1>
          <div aria-hidden="true" className="mt-7 h-px w-16 bg-bronze" data-id="element-130" data-mp="3ebioshvyf20f" />
          <p className="mt-7 max-w-xl font-serif text-xl leading-snug text-navy-700 sm:text-2xl" data-id="element-131" data-mp="30gge7hg5woha">
            {profile.headline}
          </p>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-steel-400" data-id="element-132" data-mp="2qjv9yybyvhei">
            {profile.subHeadline}
          </p>

          <ul className="mt-9 flex flex-col gap-3 border-l border-steel-100 pl-5" data-id="element-133" data-mp="2vi56bc9fgo1p">
            {facts.map(({
            icon: Icon,
            text
          }) => <li key={text} className="flex items-center gap-3" data-id="element-134" data-mp="2hjynn3d1uumm">
                <Icon className="h-4 w-4 shrink-0 text-bronze-600" aria-hidden="true" data-id="element-135" data-mp="2ljpa4uvjmolc" />
                <span className="text-sm font-medium text-navy-700" data-id="element-136" data-mp="s2b89zesml5o">{text}</span>
              </li>)}
          </ul>

          <div className="mt-10 flex flex-col flex-wrap gap-3 sm:flex-row sm:items-center" data-id="element-137" data-mp="n9qid8z0cs7f">
            <button type="button" onClick={onRequestBriefing} className="focus-ring group inline-flex items-center justify-center gap-2 rounded-sm bg-navy px-7 py-4 text-sm font-semibold text-white transition-colors duration-150 ease-exec hover:bg-navy-700" data-id="element-138" data-mp="id050tel8app">
              Request Executive Advisory / Board Briefing
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-exec group-hover:translate-x-1" aria-hidden="true" data-id="element-139" data-mp="1126m6bzqgu9e" />
            </button>
            <a href="#portfolio" className="focus-ring inline-flex items-center justify-center gap-2 rounded-sm border border-steel-200 px-7 py-4 text-sm font-semibold text-navy transition-colors duration-150 ease-exec hover:border-navy hover:bg-canvas" data-id="element-140" data-mp="3lt74sotvtnt7">
              Explore Track Record &amp; $850M+ Portfolio
            </a>
          </div>
        </motion.div>

        <motion.figure initial={{
        opacity: 0,
        scale: 0.98
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-md lg:max-w-none" data-id="element-141" data-mp="268y53i9q5z3i">
          <div aria-hidden="true" className="absolute -left-4 -top-4 h-24 w-24 border-l border-t border-bronze/50" data-id="element-142" data-mp="2kydv2w1fm0i5" />
          <img src={profile.portraitUrl} alt={`Portrait of ${profile.name}`} className="relative aspect-[4/5] w-full object-cover object-top" data-id="element-143" data-mp="2p08rpn8f3ppl" />
          <figcaption className="relative mt-5 flex items-center justify-between gap-6 border-t border-steel-200 pt-4" data-id="element-144" data-mp="umzky379aib1">
            <span className="text-[11px] font-semibold uppercase tracking-overline text-steel-400" data-id="element-145" data-mp="zmc3ibr3h37t">
              Founder &amp; Principal
            </span>
            <span className="font-serif text-sm text-navy" data-id="element-146" data-mp="3vhp25o68nwlr">
              Conroy Advisory Group, LLC
            </span>
          </figcaption>
        </motion.figure>
      </div>
    </section>;
}